import { useQuery } from "@tanstack/react-query";
import { GINO_QUERY_KEYS } from "../queryKeys";
import { getMessages } from "../services/chat";

export const useGetMessages = (chatId: string | null) => {
  return useQuery({
    queryKey: GINO_QUERY_KEYS.CHAT_MESSAGES(chatId!),
    queryFn: () => {
      if (!chatId) return Promise.resolve([]);
      return getMessages(Number(chatId));
    },
    enabled: !!chatId,
  });
};
